/**
 * TanStack-Query hook for fetching the org's Slack connection status.
 *
 * Shares the cache key `['slackStatus', orgId]` with SlackIntegration.tsx so
 * both components read from the same cached response without extra fetches.
 *
 * On query error the hook returns no data and consumers treat Slack as
 * not-connected (silent degradation is intentional — the Slack channel row
 * simply does not render).
 */

import { useQuery } from '@tanstack/react-query';

import { apiGet } from '@/lib/http/client';

export interface SlackStatus {
  connected: boolean;
  workspace_name?: string;
}

export function useSlackStatus(orgId: number | string | null | undefined) {
  return useQuery<SlackStatus>({
    queryKey: ['slackStatus', orgId],
    queryFn: () =>
      apiGet<SlackStatus>(`/api/orgs/${orgId}/integrations/slack/status/`),
    enabled: !!orgId,
  });
}
